import {tourTypes} from 'root-config/constants.js'

export const tourTypesEnum = {
  GUIDED_HOLIDAY: tourTypes.GUIDED_HOLIDAY.name,
  DAY_TOUR: tourTypes.DAY_TOUR.name,
  SHORT_BREAK: tourTypes.SHORT_BREAK.name,
}

export function getTourType ({
  tropicsOperatingCompanyCode,
  tropicsClassificationId,
  operatingCompanyCode = tropicsOperatingCompanyCode,
  classificationId = tropicsClassificationId,
}) {
  return Object.values(tourTypes)
    .find(type => {
      if (type.operatingCompanies) {
        return type.operatingCompanies.find(oc => oc.code === operatingCompanyCode)?.productClassificationIds?.includes(classificationId)
      }
    })
    ?.name || tourTypesEnum.GUIDED_HOLIDAY
}

export function isDayTour (departure) {
  return getTourType(departure) === tourTypesEnum.DAY_TOUR
}
